import React, { useState } from 'react';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../../../../components/Button';
import { Surface } from '../../../../components/Surface';
import DeleteCompanyModal from './DeleteCompanyModal';

export default function DeleteCompanyView() {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  return (
    <Surface>
      <DeleteCompanyModal open={deleteModalOpen} setOpen={setDeleteModalOpen} />

      <div className='grid gap-4'>
        <p className='text-xl font-medium text-title'>{t(TranslationKey.deleteCompanyViewTitle).singular.upper}</p>
        <div className='grid gap-2'>
          <p className='subtitle'>{t(TranslationKey.deleteCompanyViewSubtitle).singular.upper}</p>
          <p className='subtitle'>{t(TranslationKey.deleteCompanyViewConfirmationText).singular.upper}</p>
        </div>
        <div>
          <Button
            variant={ButtonVariant.danger}
            onClick={() => setDeleteModalOpen(true)}
            text={t(TranslationKey.deleteCompany).singular.upper}
          />
        </div>
      </div>
    </Surface>
  );
}
